import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/embr/assets/images/auctions.svg'


const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = { class: "flex mb-3 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "-ml-4"
  })
], -1)
const _hoisted_4 = { class: "mb-32" }

import { useRouter } from 'vue-router';
import LgeTable from '@/embr/lbp/components/LgeTable.vue';
import LgeListWarning from '@/embr/lbp/components/LgeListWarning.vue';


export default _defineComponent({
  setup(__props) {

const router = useRouter();

function goToLaunchCreate() {
  router.push({ name: 'lge-create' });
}

return (_ctx: any,_cache: any) => {
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_BalBtn, {
        class: "hidden lg:block",
        label: "Create a LBP",
        onClick: goToLaunchCreate
      })
    ]),
    _createVNode(LgeListWarning),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(LgeTable)
    ])
  ]))
}
}

})